'use strict';

require('../../style/index.less');

require('../../grid/style/index.less');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/row/style/index.js
// module id = 6
// module chunks = 0